import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import DrugStoreListComponent from 'src/components/views/DrugStore/DrugStoreListPage';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';

const mapStateToProps = ({ drugStoreState: { drugStores }, userState: { isDomestic } }: IStoreState) => ({
  drugStores,
  isDomestic,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrugStoreListComponent);



// WEBPACK FOOTER //
// ./src/containers/DrugStoreList.ts